





































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Tooltip } from 'element-ui';

import Avatar from '@/components/Avatar.vue';
import {
  ChannelFields,
  ChannelTypeEnum,
  CustomerOrganizationFields,
  SenderFields
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    Avatar,
    'el-tooltip': Tooltip
  }
})
export default class ChannelSelectItem extends Vue {
  @Prop({ required: true, type: Object }) channel!: ChannelFields;
  @Prop({ required: true, type: Object }) organization!: CustomerOrganizationFields;
  @Prop({ default: false, type: Boolean }) editable!: boolean;

  private getAvatarUrl(sender: SenderFields) {
    if (!sender.avatar) {
      return null;
    }
    return sender.avatar && sender.avatar.url;
  }

  private get partnerName(): string {
    return this.channel?.partnerMembers?.[0]?.partner?.name;
  }

  private get title(): string {
    let typedName;
    switch (this.channel.channelType) {
      case ChannelTypeEnum.private:
        typedName = this.$t('channel.title-private');
        break;
      case ChannelTypeEnum.partner:
        typedName = this.$t('channel.title');
        return `${typedName} - ${this.partnerName}`;
      case ChannelTypeEnum.public:
      default:
        typedName = this.$t('channel.title');
        break;
    }
    return `${typedName} - ${this.organization.name}`;
  }
}
